<template>
  <div class="vx-row">
    <!-- <div class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div> -->
    <!-- <vx-card> -->
    <div class="w-full">
      <vx-card>
        <div v-if="TransactionData[0].reversed == true" class="vx-row mb-3 row-align">
          <div class="list-heading"></div>
          <div class="reversed-text">{{$t("accounting.label.ThisTransactionIsReversed")}}</div>
        </div>
        <div class="vx-row mb-3 row-align">
          <feather-icon
            class="back-arrow"
            icon="ArrowLeftIcon"
            @click="$router.go(-1)"
            svgClasses="text-dark"
          />
          <div class="list-heading">
            {{ $t("accounting.label.viewtransaction") }}
          </div>
          <vs-button
            icon-pack="feather"
            icon="icon-refresh-ccw"
            @click="reversePopup = true"
            size="small"
            >{{ $t("accounting.label.reverse") }}</vs-button
          >
        </div>
        <div class="block overflow-x-auto">
          <table class="table w-full table-bordered table-striped">
            <tr>
              <td>
                <b>{{ $t("accounting.label.transactionid") }}</b>
              </td>
              <td v-if="transactionId">{{ transactionId }}</td>
            </tr>
            <tr v-if="transactionData.transactionDate">
              <td>
                <b>{{ $t("accounting.label.transactiondate") }}</b>
              </td>
              <td>{{ getDate(transactionData.transactionDate) }}</td>
            </tr>
            <tr v-if="transactionData.createdDate">
              <td>
                <b>{{ $t("accounting.label.createdon") }}</b>
              </td>
              <td>{{ getDate(transactionData.createdDate) }}</td>
            </tr>
            <tr v-if="transactionData.createdByUserName">
              <td>
                <b>{{ $t("accounting.label.createdby") }}</b>
              </td>
              <td>{{ transactionData.createdByUserName }}</td>
            </tr>
            <tr v-if="transactionData.officeName">
              <td>
                <b>{{ $t("accounting.label.entity") }}</b>
              </td>
              <td>{{ transactionData.officeName }}</td>
            </tr>
          </table>
        </div>
        <vs-table
          :max-items="paginationItems[0]"
          pagination
          :data="TransactionData"
        >
          <template slot="thead">
            <vs-th>{{ $t("accounting.label.entryid") }}</vs-th>
            <vs-th>{{ $t("accounting.label.type") }}</vs-th>
            <vs-th>{{ $t("accounting.label.account") }}</vs-th>
            <vs-th>{{ $t("accounting.label.debit") }}</vs-th>
            <vs-th>{{ $t("accounting.label.credit") }}</vs-th>
            <!-- <vs-th class="tHeadCenter">{{
              $t("accounting.label.action")
            }}</vs-th> -->
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="index" :data="data" v-for="(accounts, index) in data">
              <vs-td>{{ accounts.id }}</vs-td>
              <vs-td>{{ accounts.glAccountType.value }}</vs-td>
              <vs-td
                >{{ accounts.glAccountName }} ({{
                  accounts.glAccountCode
                }})</vs-td
              >
              <vs-td>
                <template v-if="accounts.entryType.value === 'DEBIT'">
                  {{ accounts.amount }}
                </template>
                <template v-else> </template>
              </vs-td>
              <vs-td>
                <template v-if="accounts.entryType.value === 'CREDIT'">
                  {{ accounts.amount }}
                </template>
                <template v-else> </template>
              </vs-td>

              <!-- <vs-td class="whitespace-no-wrap">
                <div class="container_img">
                  <feather-icon
                    icon="EyeIcon"
                    title="View"
                    svgClasses="w-5 h-5 stroke-current cursor text-primary"
                    @click.stop="handleSelected1(accounts.id)"
                    class="icon_row"
                  />
                </div>
              </vs-td> -->
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <!-- </vx-card> -->
    <div class="centerx">
      <vs-popup
        class="popup-close"
        :title="$t('accounting.label.reverse')"
        :active.sync="reversePopup"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col mb-2 w-full">
              <small class="date-label font-semibold">{{
                $t("accounting.label.comments")
              }}</small>
              <vs-textarea v-model="comments" />
            </div>
          </div>
          <div class="center">
            <span class="ml-1 mr-1">
              <vs-button
                class="mr-4"
                type="border"
                @click="reversePopup = false"
                >{{ $t("accounting.label.cancel") }}</vs-button
              >
              <vs-button :disabled="!comments" @click="handleReverse">{{
                $t("accounting.label.reverse")
              }}</vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";
import moment from "moment";

export default {
  data() {
    return {
      reversePopup: false,
      transactionId: "",
      transactionData: "",
      comments: "",
      paginationItems: [10, 20, 30],
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      TransactionData: (state) => state.accounting.transactionDetails,
      ReverseTransactionId: (state) => state.accounting.reverseTransactionId,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getDate(date) {
      const d = new Date(date);
      return moment(d).format(this.formattedDate);
    },
    async getTransactionDetailsMethod(id) {
      try {
        await this.$store.dispatch("accounting/transactionDetailsAction", id);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async handleOkClick(id) {
      await this.$router.push({
        name: "View Transaction",
        params: { id: id },
      });
      await this.getTransactionDetailsMethod(id);
      this.transactionId = id;
    },
    async handleReverse() {
      this.reversePopup = false;
      const payload = {
        transactionId: this.transactionId,
        comments: this.comments,
      };
      try {
        await this.$store.dispatch(
          "accounting/reverseTransactionAction",
          payload
        );
        this.$swal({
          title: "Success",
          icon: "success",
          html: `
    <p>Transaction reversed successfully. A new journal entry has been created to reverse this transaction.</p>
    <p style="margin-top: 20px; font-weight: bold; text-align: center;">
      Transaction Number: ${this.ReverseTransactionId.transactionId}
    </p>
  `,
          type: "success",
          showCancelButton: true,
          reverseButtons: true,
          focusConfirm: false,
          confirmButtonText: "Redirect To New Transaction",
          preConfirm: () => {
            return this.handleOkClick(this.ReverseTransactionId.transactionId);
          },
        });
      } catch (error) {
        this.$swal({
          title: "Error",
          icon: "warning",
          text: "Something went wrong",
          type: "warning",
        });
      }
    },

    handleSelected1(id) {
      this.$router.push({
        name: "View Accounting Rule",
        params: { id: id },
      });
    },
  },
  async mounted() {
    console.log(this.$route.params.id, "route id" )
    this.transactionId = this.$route.params.id;
    if(this.$route.params.data){
      this.transactionData = this.$route.params.data;
    }
    await this.getTransactionDetailsMethod(this.transactionId);
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.back-arrow {
  cursor: pointer;
}
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
.row-align {
  align-items: baseline;
}
.reversed-text {
  color: red;
  font-size: 1.2rem;
  font-weight: 600;
}
</style>
